/**
 * DeleteCarouselModalController is a controller for handling the modal dialog
 * for deleting a carousel. It manages the user interactions and the modal's
 * lifecycle.
 */
export default class DeleteCarouselModalController {
    /**
     * Constructs the DeleteCarouselModalController.
     * 
     * @param {Object} $scope - The AngularJS scope object.
     * @param {Object} $uibModalInstance - The instance of the modal dialog.
     */
    constructor($scope, $uibModalInstance) {
        this.$scope = $scope;
        this.$uibModalInstance = $uibModalInstance;

        // Bind methods to the current instance to maintain context
        this.$scope.onCancelButton = this.onCancelButton.bind(this);
        this.$scope.onDelete = this.onDelete.bind(this);
    }

    /**
     * Handles the cancel button click event.
     * Sets the delete flag to false and dismisses the modal.
     */
    onCancelButton() {
        this.$uibModalInstance.isDeleted = false;
        this.$uibModalInstance.dismiss('cancel');
    }

    /**
     * Handles the delete button click event.
     * Sets the delete flag to true and dismisses the modal.
     */
    onDelete() {
        this.$uibModalInstance.isDeleted = true;
        this.$uibModalInstance.dismiss('delete');
    }
}